export async function getUserCountry(): Promise<string> {
  const data = await (
    await fetch('https://cgi.pitchup.com/cdn-cgi/trace')
  ).text()
  return getLocationValueFromTraceResponse(data)
}

function getLocationValueFromTraceResponse(data: string): string {
  for (const line of data.split('\n')) {
    const element = line.split('=')
    if (element[0] === 'loc') return element[1]
  }
  return ''
}
